/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
  const group = useRef();
  const { nodes, materials } = useGLTF("3D/halloradioraumLowRes.glb");
  return (
    <group ref={group} {...props} dispose={null}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor001.geometry}
        material={nodes.Floor001.material}
        position={[0, 0, 0.5]}
        rotation={[Math.PI / 2, 0, 0]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor003.geometry}
        material={nodes.Floor003.material}
        position={[0, 0, 0.5]}
        rotation={[Math.PI / 2, 0, 0]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor004.geometry}
        material={nodes.Floor004.material}
        position={[0, 0, 0.5]}
        rotation={[Math.PI / 2, 0, 0]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor005.geometry}
        material={nodes.Floor005.material}
        position={[0, 0, 0.5]}
        rotation={[Math.PI / 2, 0, 0]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor028.geometry}
        material={nodes.Floor028.material}
        position={[0, 0, 0.5]}
        rotation={[Math.PI / 2, 0, 0]}
      />
      <group position={[3.04, 1.9, 1.57]} rotation={[Math.PI / 2, 0, -0.71]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche071.geometry}
          material={nodes.Fläche071.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche071_1.geometry}
          material={nodes.Fläche071_1.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche071_2.geometry}
          material={nodes.Fläche071_2.material}
        />
      </group>
      <group position={[-0.69, 0, 0.5]} rotation={[Math.PI / 2, 0, 0]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche075.geometry}
          material={nodes.Fläche075.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche075_1.geometry}
          material={materials.Material}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor075.geometry}
        material={nodes.Floor075.material}
        position={[0, 0, 0.5]}
        rotation={[Math.PI / 2, 0, 0]}
      />
      <group
        position={[-2.05, 2.81, -0.07]}
        rotation={[Math.PI / 2, 0.57, 0]}
        scale={[1.01, 1.01, 1.01]}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche001.geometry}
          material={nodes.Fläche001.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche001_1.geometry}
          material={nodes.Fläche001_1.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche001_2.geometry}
          material={nodes.Fläche001_2.material}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor073.geometry}
        material={nodes.Floor073.material}
        position={[0, 0, 2.17]}
        rotation={[Math.PI / 2, 0, 0]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor010.geometry}
        material={materials["Material.015"]}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor013.geometry}
        material={nodes.Floor013.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor014.geometry}
        material={nodes.Floor014.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor015.geometry}
        material={nodes.Floor015.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor016.geometry}
        material={nodes.Floor016.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor038.geometry}
        material={nodes.Floor038.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor041.geometry}
        material={nodes.Floor041.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor042.geometry}
        material={nodes.Floor042.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor131.geometry}
        material={nodes.Floor131.material}
        position={[0.64, 2.31, 2.71]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor368.geometry}
        material={nodes.Floor368.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor370.geometry}
        material={nodes.Floor370.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor379.geometry}
        material={nodes.Floor379.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor380.geometry}
        material={nodes.Floor380.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor382.geometry}
        material={nodes.Floor382.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor385.geometry}
        material={nodes.Floor385.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <group position={[-9.63, 1.65, -2.74]} rotation={[2.08, -0.08, 2.04]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche019.geometry}
          material={nodes.Fläche019.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche019_1.geometry}
          material={nodes.Fläche019_1.material}
        />
      </group>
      <group position={[-9.63, 1.65, -2.74]} rotation={[2.08, -0.08, 2.04]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche023.geometry}
          material={nodes.Fläche023.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche023_1.geometry}
          material={nodes.Fläche023_1.material}
        />
      </group>
      <group position={[-9.63, 1.65, -2.74]} rotation={[2.08, -0.08, 2.04]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche024.geometry}
          material={nodes.Fläche024.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche024_1.geometry}
          material={nodes.Fläche024_1.material}
        />
      </group>
      <group position={[-9.63, 1.65, -2.74]} rotation={[2.08, -0.08, 2.04]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche025.geometry}
          material={nodes.Fläche025.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche025_1.geometry}
          material={nodes.Fläche025_1.material}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor376.geometry}
        material={materials["Material.029"]}
        position={[-9.63, 1.65, -2.74]}
        rotation={[2.08, -0.08, 2.04]}
      />
      <group position={[0, 0, 0.5]} rotation={[Math.PI / 2, 0, 0]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche.geometry}
          material={materials["Material.010"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche_1.geometry}
          material={materials["Material.020"]}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor002.geometry}
        material={materials["Material.018"]}
        position={[0, 0, 0.5]}
        rotation={[Math.PI / 2, 0, 0]}
      />
      <group position={[0, 0, 0.5]} rotation={[Math.PI / 2, 0, 0]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche022.geometry}
          material={materials.couch}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche022_1.geometry}
          material={nodes.Fläche022_1.material}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor024.geometry}
        material={nodes.Floor024.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor007.geometry}
        material={nodes.Floor007.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor008.geometry}
        material={nodes.Floor008.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor009.geometry}
        material={nodes.Floor009.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor006.geometry}
        material={nodes.Floor006.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor012.geometry}
        material={nodes.Floor012.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor011.geometry}
        material={materials["Material.002"]}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor017.geometry}
        material={nodes.Floor017.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor018.geometry}
        material={nodes.Floor018.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor020.geometry}
        material={materials["Material.028"]}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <group
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche039.geometry}
          material={materials.Screen}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche039_1.geometry}
          material={nodes.Fläche039_1.material}
        />
      </group>
      <group
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche040.geometry}
          material={nodes.Fläche040.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche040_1.geometry}
          material={nodes.Fläche040_1.material}
        />
      </group>
      <group
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche422.geometry}
          material={nodes.Fläche422.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche422_1.geometry}
          material={nodes.Fläche422_1.material}
        />
      </group>
      <group
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche423.geometry}
          material={nodes.Fläche423.material}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche423_1.geometry}
          material={nodes.Fläche423_1.material}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor023.geometry}
        material={nodes.Floor023.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor025.geometry}
        material={nodes.Floor025.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor026.geometry}
        material={nodes.Floor026.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor027.geometry}
        material={nodes.Floor027.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor029.geometry}
        material={nodes.Floor029.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor030.geometry}
        material={nodes.Floor030.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor031.geometry}
        material={nodes.Floor031.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor032.geometry}
        material={nodes.Floor032.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor033.geometry}
        material={nodes.Floor033.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor034.geometry}
        material={nodes.Floor034.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor035.geometry}
        material={nodes.Floor035.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor036.geometry}
        material={nodes.Floor036.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor037.geometry}
        material={nodes.Floor037.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <group
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      >
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche087.geometry}
          material={materials["Material.022"]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Fläche087_1.geometry}
          material={materials["Material.003"]}
        />
      </group>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor040.geometry}
        material={nodes.Floor040.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor369.geometry}
        material={nodes.Floor369.material}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor387.geometry}
        material={materials["Material.006"]}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Icosphere.geometry}
        material={materials["Material.007"]}
        position={[0, 6.32, 0]}
        scale={0.68}
      />
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Floor371.geometry}
        material={materials["Material.009"]}
        position={[1.17, 0.92, 2.88]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={[2, 2, 1.02]}
      />
    </group>
  );
}

useGLTF.preload("3D/halloradioraumLowRes.glb");
